import { SvgIcon, SvgIconProps } from '@mui/material'
import { NovaColours, useAppContext } from '@novafuturltd/core'

export const ListOrderingIcon = (props: SvgIconProps) => {
  const { mode } = useAppContext()
  const defaultFill = NovaColours.N040[mode]

  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M5 20H2V19H4V18.5H3V17.5H4V17H2V16H5V20ZM21 19H7V17H21V19ZM5 10.9004L3.2002 13H5V14H2V13.0996L3.7998 11H2V10H5V10.9004ZM21 11V13H7V11H21ZM4 8H3V5H2V4H4V8ZM21 7H7V5H21V7Z"
        fill={defaultFill}
      />
    </SvgIcon>
  )
}

export default ListOrderingIcon
